import {
  init,
  identify,
  shutdown,
  getCurrentSessionURL,
  restart,
} from '@fullstory/browser';
import logger from './loggerManager';
import { addToContext } from './contextManager';
import { environment } from '../environment';

export const initFS = () => {
  init({
    orgId: 'KSP04',
    namespace: 'StoreAppFS',
    host: 'fullstory.com',
    script: 'edge.fullstory.com/s/fs.js',
    debug: environment.envName === 'development',
  });
};

export const startFsRecording = (userEmail: string, userId?: string) => {
  restart();
  identify(`storeapp-fs-${userId ?? userEmail}`);
  trackRecordingStart();
};

export const stopFsRecording = (userEmail: string) => {
  const fullStoryLink = getFsSessionUrl(false);
  logger.log(`Fullstory recording ended. link: ${fullStoryLink}`, {
    filename: 'fullStoryManager.ts',
    function: 'stopFsRecording',
  });

  shutdown();
  startFsRecording(userEmail);
};

export const getFsSessionUrl = (now: boolean = true) => {
  const fsCurrentSessionUrl = getCurrentSessionURL(now)!;
  addToContext('fullStoryLink', fsCurrentSessionUrl);
  return fsCurrentSessionUrl;
};

const trackRecordingStart = () => {
  const fullStoryLink = getFsSessionUrl();
  if (fullStoryLink) {
    logger.log('Session Recording Started', {
      filename: 'fullStoryManager.ts',
      function: 'trackRecordingStart',
    });
  } else {
    setTimeout(() => {
      trackRecordingStart();
    }, 500);
  }
};
